class RecommendedProducts extends HTMLElement {
  constructor () {
    super();

    this.onScrollIntoView = this.onScrollIntoView.bind(this);

    this.state = {
      loaded: false
    }

    const observer = new IntersectionObserver(this.onScrollIntoView);
    observer.observe(this);
  }

  onScrollIntoView (entries) {
    if (!entries[0].isIntersecting || this.state.loaded) {
      return;
    }

    this.state.loaded = true;

    return fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        var container = document.createElement('div');
        container.innerHTML = text;
        this.innerHTML = container.querySelector('recommended-products').innerHTML;
      })
  }
}

customElements.define('recommended-products', RecommendedProducts);
